import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'en',
    messages: {
        en: {
            email: 'Email',
            password: 'Password',
            enter: 'ENTER',
            fields_not_null: 'The fields cannot be empty',
            logout: 'LOG OUT',
            reference: 'Reference',
            partner: 'Partner',
            date: 'Date',
            guest: 'Guest',
            save: 'SAVE',
            saved_changes: 'Changes saved',
            scan_again: 'SCAN ANOTHER CARD',
            invalid_code: 'Invalid QR-Code',
            invalid_credentials: 'Invalid credentials',
            not_allowed_error: 'ERROR: you need to grant camera access permission',
            not_found_error: 'ERROR: no camera on this device',
            not_supported_error: 'ERROR: secure context required (HTTPS, localhost)',
            not_readable_error: 'ERROR: is the camera already in use?',
            overconstrained_error: 'ERROR: installed cameras are not suitable',
            not_supported_api_error: 'ERROR: Stream API is not supported in this browser',
            title: 'Omega European Masters',
            access_control: 'Access control',
            access_card: 'Access card'
        },
        fr: {
            email: 'Email',
            password: 'Mot de passe',
            enter: 'ENTRER',
            fields_not_null: 'Les champs ne peuvent pas être vides',
            logout: 'SE DECONNECTER',
            reference: 'Référence',
            partner: 'Partenaire',
            date: 'Date',
            guest: 'Invité',
            save: 'ENREGISTRER',
            saved_changes: 'Modifications sauvegardées',
            scan_again: 'SCANNER UNE AUTRE CARTE',
            invalid_code: 'QR-Code invalide',
            invalid_credentials: 'Identifiants invalides',
            not_allowed_error: 'ERREUR: vous devez donner la permission d\'utiliser l\'appareil photo',
            not_found_error: 'ERREUR: cet appareil ne possède pas d\'appareil photo',
            not_supported_error: 'ERREUR: contexte sécurisé requis (HTTPS, localhost)',
            not_readable_error: 'ERREUR: est-ce que l\'appareil photo est déjà utilisé ?',
            overconstrained_error: 'ERREUR: les caméras installées ne conviennent pas',
            not_supported_api_error: 'ERREUR: Stream API n\'est pas pris en charge dans ce navigateur.',
            title: 'Omega European Masters',
            access_control: 'Contrôle d\'accès',
            access_card: 'Carte d\'accès'
        },
        de: {
            email: 'Email',
            password: 'Passwort',
            enter: 'EINGEBEN',
            fields_not_null: 'Die Felder dürfen nicht leer sein',
            logout: 'ABMELDEN',
            reference: 'Referenz',
            partner: 'Partner',
            date: 'Datum',
            guest: 'Gast',
            save: 'SPEICHERN',
            saved_changes: 'Änderungen gespeicherte',
            scan_again: 'ANDERE KARTE SCANNEN',
            invalid_code: 'Ungültiger QR-Code',
            invalid_credentials: 'Ungültige Anmeldeinformationen',
            not_allowed_error: 'ERROR: Sie müssen die Zugriffsberechtigung für die Kamera erteilen.',
            not_found_error: 'ERROR: keine Kamera auf diesem Gerät',
            not_supported_error: 'ERROR: sicherer Kontext erforderlich (HTTPS, localhost)',
            not_readable_error: 'ERROR: Ist die Kamera bereits im Einsatz?',
            overconstrained_error: 'ERROR: installierte Kameras sind nicht geeignet',
            not_supported_api_error: 'ERROR: Die Stream-API wird in diesem Browser nicht unterstützt.',
            title: 'Omega European Masters',
            access_control: 'Zutrittskontrolle',
            access_card: 'Zutrittskarte'
        }
    }
});
